<mat-card-header>
  <div style="width:90%">
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <mat-card-title fxFlex="90%">
        Coletore(s) Inválido(s)
      </mat-card-title>
      <mat-icon
        (click)="exporter.exportTable('xlsx', {fileName:'ColetoresErro', sheet: 'ColetoresErro', Props: {Author: 'MRVPag'}})"
        fxFlex="10%" class="pointer">save_alt</mat-icon>
    </div>
  </div>
  <div style="width:10%; cursor:pointer;">
  </div>
</mat-card-header>
<mat-card-content>
  <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
    <div style="padding: 0px !important;">
      <div class="table-container">
        <table mat-table matTableExporter [dataSource]="dataSource" #exporter="matTableExporter" style="width: 100%">

          <!-- codColetorCusto Column -->
          <ng-container matColumnDef="codColetorCusto">
            <th mat-header-cell *matHeaderCellDef style="width: 35%"> Código Erro </th>
            <td mat-cell *matCellDef="let element"> {{element.codColetorCusto}} </td>
          </ng-container>

          <!-- codColetorCusto Column -->
          <ng-container matColumnDef="idx">
            <th mat-header-cell *matHeaderCellDef> Linha Planilha </th>
            <td mat-cell *matCellDef="let element"> {{element.idx}} </td>
          </ng-container>

          <!-- descMensagem Column -->
          <ng-container matColumnDef="descMensagem">
            <th mat-header-cell *matHeaderCellDef> Mensagem de Erro </th>
            <td mat-cell *matCellDef="let element"> {{element.descMensagem}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</mat-card-content>